import { createPassUpdate } from 'components/reusable/pass';
import { EventTicket } from '../../../../ui/data-display/Passes/eventTicket';
import { useRetrieveEventTicketTemplateQuery, useUpdateEventTicketMutation } from 'services/eventTickets';


export const UpdateEventTicket = createPassUpdate({
  TemplateRenderer: EventTicket,
  retrieveTemplateHook: useRetrieveEventTicketTemplateQuery,
  updatePassHook: useUpdateEventTicketMutation,
  i18nNamespace: 'pass',
  baseUrl: '/event-tickets/',
})